import React from 'react';
import { StyledParagraph, StyledLink } from '../styles/Typography.styled';
import { ProjectsContainer, StyledProjects } from '../styles/Projects.styled';
import { SectionHeading, SectionTitle } from '../styles/SectionHeading';
import { ProjectData } from './ProjectsData';
import ProjectCardComponent from './ProjectsCard';

const Projects = () => {
  return (
    <StyledProjects id="projects">
      <SectionHeading>
        <SectionTitle number="01">Projects</SectionTitle>
      </SectionHeading>
      <StyledParagraph dark="true" textAlign="center">
        Recent projects on which I have worked{' '}
        <StyledLink
          href="https://github.com/Vasanth1009"
          target="_blank"
          rel="noopener noreferrer"
        >
          Looking for more?
        </StyledLink>
      </StyledParagraph>
      <ProjectsContainer>
        {ProjectData.map((project, index) => {
          return <ProjectCardComponent key={index} {...project} />;
        })}
      </ProjectsContainer>
    </StyledProjects>
  );
};

export default Projects;
